var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "show-modal-link__container" },
    [
      _c(
        "p",
        { staticClass: "show-modal-link", on: { click: _vm.showModal } },
        [_vm._v(_vm._s(_vm.text))]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { attrs: { name: _vm.uniqueModalName, width: "50%", height: "auto" } },
        [
          _c(
            "div",
            { staticClass: "modal__content" },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("div", { staticClass: "modal__footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--hollow btn--block btn--small",
                    on: { click: _vm.closeModal },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.closeButtonText) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }